define('utils/format',[],function() {
    var pad = function(n, padChar, padSize) {
        var nAsString = n.toString();
        if (padChar.length > 1) {
            return nAsString;
        }
        while (nAsString.length < padSize) {
            nAsString = padChar + nAsString;
        }
        return nAsString;
    };

    return {
        /**
         * Format the date according the format "YYYY-mm-dd"
         * 
         * @param d
         *            the date as javascript object
         * @return the date as string in the format "YYYY-mm-dd"
         */
        formatDate: function(d) {
            return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1, '0', 2) + '-' + pad(d.getUTCDate(), '0', 2);
        },
        capitaliseFirstLetter: function(string) {
            return (string.charAt(0).toUpperCase() + string.slice(1)).replace(/_/g, " ");
        },
        /**
         * Pad a value with the given padChar until it reachs the padSize
         * 
         * @param n
         *            the value to pad
         * @param padChar
         *            the char used to pad. If it is a string, we do not pad.
         * @param padSize
         *            minimum size of the string
         * 
         * @return a string, padded with the given character if needed.
         */
        pad: pad
    };
});

